import React from 'react'

const History = () =>
  <div className="history relative">
    <div className="events">
      <Event year="2022">
        Our 1500th hire-able item is ordered and we launch our new revamped website. The new site is designed
        with simplicity and clarity in mind. Richie wanted to create a tool whereby users can hire equipment
        and get back to their lives without the process taking up too much time or effort. Keep it simple, stupid!
      </Event>
      <Event year="2021">
        We accept our 75,000th order, which was a nice milestone in what was otherwise fairly hard times due to the effects of COVID-19.
      </Event>
      <Event year="2020">
        The idea of drinking beer on a beach became just a bit too tempting for Stewart and so he sold the company to ex-lifeguard, Richie, who clearly really liked the company a lot. The Coronavirus pandemic hits the company in March and 95% of our order book was cancelled.
      </Event>
      <Event year="2014">
        Lenses For Hire becomes more Lenses (and cameras) For Hire as we introduce cameras to our inventory for the first time.
      </Event>
      <Event year="2011">
        The business now has around 400 lenses and was becoming fairly hands-on. Beccy leaves her career in IT Project Management and joins the company in March. Richie leaves his 'career' in the leisure industry and joins the company in May. They actually applied for the same job - Beccy was given it (naturally) but Richie pestered Stewart enough to give him a job anyway.
      </Event>
      <Event year="2009">
        The business had now spread to Stewart's dining room and his lounge. He had &gt;170 lenses in circulation, so his wife just had to kick the business out. By then Stewart had left his proper job and LFH moved to ONE, St Peters Road in Feb 2009.
      </Event>
      <Event year="2008">
        Stewart Robertson struggled to find anywhere to simply and affordably hire a 500mm f/4 - the idea of Lenses For Hire was born. Whilst still having a proper job in the railway industry, he made a website, bought 30 lenses and started operations from his spare room.
      </Event>
    </div>
  </div>

const Event = ({year, children}) =>
  <div className="event">
    <h2>{year}</h2>
    <p>
      {children}
    </p>
  </div>


export default History